import Devices from "../Devices/Devices"

const OfflineDevices = () => (
  <Devices
    preset={{ status: "Offline" }}
    locked={["status"]}
    title="Offline devices"
  />
)

export default OfflineDevices
